import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LocaleContext } from "../../../routing/LangRouter";
import { Grid } from "@mui/material";
import axios from "axios";
import BASE_URL from "../../../constants/baseUrls";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { navigateToLoginPage } from "../../../utils/utility";
import { IS_MOBILE } from "../../../constants/breakpoints";
import BaseTitle from "../../../components/common/base-title/base-title";

//import view components
import UserRequest from "../../../components/view/user-panel/support/user-request";
import AllRequest from "../../../components/view/user-panel/support/all-request";
import ChatRequest from "../../../components/view/user-panel/support/chat-request";

function Support() {
    //general
    const navigate = useNavigate();
    const location = useLocation();
    const [parent, enableAnimations] = useAutoAnimate(false);
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();
    const accessToken = localStorage.getItem("accessToken");
    const [loading, setLoading] = useState(false);

    //request to get request list
    const [requestList, setRequestList] = useState([]);
    const getRequestList = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${BASE_URL}/account/user/requests/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setRequestList(response.data);
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                navigateToLoginPage(navigate, locale, location);
            } else toast.error(t("errorMessage"), { toastId: "custom-id-yes" });
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getRequestList();
    }, []);

    //show or hide chat request
    const [chatRequest, setChatRequest] = useState(false);
    const [chatRequestID, setChatRequestID] = useState("");
    const handleChangeStatusButton = (value, id) => {
        enableAnimations(true);
        setChatRequest(value);
        setChatRequestID(id);
    };

    const [isList, setIsList] = useState(true);

    return (
        <Grid className="support" container item xs={12} rowGap={2} mt={{ xs: 2, md: 0 }} mb={5} ref={parent}>
            {!IS_MOBILE && <BaseTitle title={`${t("support")}`} dividerColor="1px solid var(--medium-gray-color)" />}
            {!chatRequest ? (
                <Grid container rowGap={{ md: 5 }}>
                    <UserRequest requestList={requestList} getRequestList={getRequestList} setIsList={setIsList} />
                    {isList && <AllRequest requestList={requestList} handleChangeStatusButton={handleChangeStatusButton} loading={loading} />}
                </Grid>
            ) : (
                <ChatRequest handleChangeStatusButton={handleChangeStatusButton} chatRequestID={chatRequestID} />
            )}
        </Grid>
    );
}

export default Support;
